import { Input } from '@chakra-ui/react';
const CUIInput = Input;
export default CUIInput;